<template>
  <div class="select-table" :style="{ background: !isEmpty(config.filedInfo) ? '#fff' : ''}">
    <template v-if="!isEmpty(config.filedInfo)">
      <NoData text="请设置选入字段" />
    </template>
    <template v-else>
      <page-explain :config="config" v-if="config.pageExplain" />
      <div class="select-table-content">
        <VueDraggableResizable @resizestop="resizeEnd" style="position: relative;height: 100%;" :handles="isConfig ? ['mr'] : []" :w="config.colWidth || 120" :draggable="false">
          <template v-if="config.filedInfo.headerConfg">
            <selectTree :key="keyIndex" @nodeClick="checkOptions" :screenInfo="config.filedInfo.headerConfg" :levelList="config.filedInfo.headerConfg.screenLevel.levelList" />
          </template>
        </VueDraggableResizable>
        <div class="conent-right">
          <div class="conent-right-nav" v-if="colList.length > 1">
            <div class="nav-content">
              <div class="nav-content-item" @click="changeActiveId(item)" :class="activeColInfo.id === item.id ? 'nav-active' : ''" v-for="(item, index) in colList" :key="index">
                <selectEdit v-if="isConfig" @click.stop @goEdit="goEditTitle(item, index)" />
                <span :style="item.fontStyle">
                  {{ item.label }}
                </span>
              </div>
            </div>
          </div>
          <div class="conent-right-table" :class="config.layout === 'row' ? 'row-table-content' : ''">
            <div class="col-item row-item" v-for="(col, idx) in activeColInfo.colItem" :key="col.id">
              <div class="col-item-title row-item-title" ref="colItemTitleRef" :style="{
                width: config.layout === 'row' ? `${col.customSize || 60}px` : '',
                height: config.layout === 'col' ? `${col.customSize || 60}px` : '',
              }">
                <styleModule :parentCustomData="customData" :curNum="tableData[col.id] && tableData[col.id].length" :dataInfo="col.styleInfo.styleInfo" :bgSelect="col.styleInfo.bgSelect" v-if="col.styleInfo" style="z-index: 1;" />
                <selectEdit v-if="isConfig" @goEdit="goEditCol(col, idx)" />
              </div>
              <div class="col-item-content row-item-title" :class="checkColId.includes(col.id) ? 'col-item-active' : ''" @click="checkCol(col)">
                <template v-if="tableData[col.id]">
                  <draggable class="check-draggable" v-model="tableData[col.id]" animation="300" group="select">
                    <template v-for="(item, cidx) in tableData[col.id]" :key="cidx">
                      <div class="check-card" v-if="item.cardConfig">
                        <CardForm :data="item.dataRow" :key="item.id" :cardConfig="item.cardConfig" :isNewCard="true"/>
                        <selectEdit>
                          <i class="iconfont icon-a-shanchu2x" @click.stop="deleteItem(cidx, col.id)"></i>
                        </selectEdit>
                      </div>
                      <div class="check-item" :key="item.id" v-else>
                        <span class="title">{{ item.label }}</span>
                        <span class="close" @click.stop="deleteItem(cidx, col.id)">
                          <i class="el-icon-close"></i>
                        </span>
                      </div>
                    </template>
                  </draggable>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <colSet ref="colSetRef" :fieldList="appInfo.fieldList" @confirm="colSetConfirm" />
      <titleSet ref="titleSet" @confirm="titleSetConfirm" />
    </template>
  </div>
</template>

<script>
import { testRows, getParentNode, getNode, importData, strToObject, defaultValuesForParameterTransmission } from '../utils'
import { isEmpty } from 'lodash'
import { cloneDeep } from 'lodash'

import pageExplain from '../common/pageExplain.vue'
import VueDraggableResizable from 'vue3-draggable-resizable'
import selectEdit from '../common/selectEdit.vue'
import styleModule from '@/components/schoolInstrument/common/styleModule.vue'
import colSet from './colSet.vue'
import titleSet from './titleSet.vue'
import draggable from 'vuedraggable'
import CardForm from '@/components/common/card/cardForm.vue'
import NoData from '../common/noData.vue'
import { defineAsyncComponent } from 'vue'

export default {
  // 组件名称
  name: 'selectTable',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    isConfig: {
      type: Boolean,
      default: true
    },
    appInfo: {
      type: Object,
      default: () => ({})
    },
    activeColInfo: {
      type: Object,
      default: () => ({})
    },
    queryData: {
      type: Object,
      default: () => ({})
    },
    customData: {
      type: Array,
      default: () => []
    },
    property: {
      type: Array,
      default: ()=>([])
    }
  },
  // 局部注册的组件
  components: {
    VueDraggableResizable,
    pageExplain,
    styleModule,
    selectEdit,
    colSet,
    draggable,
    titleSet,
    CardForm,
    NoData,
    selectTree: defineAsyncComponent(() => import('./selectTree'))
  },
  // 组件状态值
  data () {
    return {
      tableData: {},
      checkColId: [],
      tempColIdx: -1,
      openType: 'col',
      testRows,
      keyIndex: 1
    }
  },
  // 计算属性
  computed: {
    colList() {
      return this.config.colList || []
    }
  },
  mounted() {
    this.initData()
  },
  // 侦听器
  watch: {
    'config.filedInfo': {
      handler (val) {
        if (val && JSON.stringify(val) !== '{}') {
          this.keyIndex++
        }
      },
      deep: true,
      immediate: true
    }
  },
  // 组件方法
  methods: {
    isEmpty(obj){
      return !isEmpty(obj)
    },
    clearTable() {
      this.initData(true)
    },
    async submit(params = {}, msg) {
      let data = this.getAllData()
      let isIncludesDetail = false
      const fileProperty = this.appInfo.fileProperty || {}
      for (const key in fileProperty) {
        const ele = fileProperty[key]
        if (ele.type.includes('details')) {
          isIncludesDetail = true
        }
      }
      let search = this.queryData.search
      let query = {}
      if (search) {
        search = strToObject(search)
        for (const key in search) {
          const [title] = key.split('_') 
          const filed = fileProperty[title]
          query[`${key}_${filed.name}`] = search[key]
        }
      }
      // 要是后台改好了 这边注释
      const dataList = []
      for (const item of data) {
        let value = { ...params, ...item, ...query }
        const formdata = defaultValuesForParameterTransmission(this.property, value, true)
        const foemdata = cloneDeep(formdata)
        for (const key in foemdata) {
          const ele = foemdata[key]
          if (!ele) {
            delete formdata[key]
          } else if (ele && Array.isArray(ele) && (ele.length === 0 || !ele[0])) {
            delete formdata[key]
          } else if (ele && typeof ele === 'object' && Object.keys(ele).length === 0) {
            delete formdata[key]
          }
        }
        dataList.push(formdata)
      }
      await importData(dataList, { approvalId: this.appInfo.id, isIncludesDetail, msg })
    },
    getAllData() {
      const colList = []
      for (const ele of this.colList) {
        colList.push(...ele.colItem)
      }
      let paramsList = this.queryData.paramsList || []
      if (paramsList && !Array.isArray(paramsList)) {
        paramsList = JSON.parse(paramsList)
      }
      const data = []
      for (const key in this.tableData) {
        const li = this.tableData[key]
        const col = colList.find(item => item.id === Number(key))
        if (col) {
          let customize = cloneDeep(col.customize) || []
          const customLi = customize.filter(item => item.type !== 'variable')
          const variable = customize.filter(item => item.type === 'variable')
          let totalFiled = {}
          for (const ele of customLi) {
            if (ele.condition === 'eq') {
              const key = ele.conditionValue
              totalFiled[key] = ele.value
            }
          }
          for (const ele of variable) {
            if (ele.condition === 'eq' && ele.value) {
              const [name] = ele.value.split('_')
              const param = paramsList.find(ele => ele.name === name)
              if (param) {
                const key = ele.conditionValue
                totalFiled[key] = param.value
              } else {
                const key = ele.conditionValue
                const custom = this.customData.find(f => f.name === name)
                if (custom) {
                  totalFiled[key] = custom.value
                }
              }
            }
          }
          for (const ele of li) {
            const filed = getNode(ele)
            data.push({...filed, ...totalFiled})
          }
        }
      }
      return data
    },
    titleSetConfirm(val) {
      // eslint-disable-next-line vue/no-mutating-props
      this.config.colList[this.tempColIdx] = val
      this.tempColIdx = -1
    },
    goEditTitle(item, idx) {
      this.tempColIdx = idx
      this.$refs.titleSet.open(item)
    },
    deleteItem(cidx, id) {
      this.tableData[id].splice(cidx, 1)
    },
    deleteTable() {
      const col = this.activeColInfo.colItem
      const id = col[col.length].id
      this.$delete(this.tableData, id)
    },
    initData(isClear = false) {
      if (isClear) this.tableData = {}
      const col = this.activeColInfo.colItem || []
      for (const item of col) {
        if (!this.tableData[item.id]) {
          this.tableData[item.id] = []
        }
      }
    },
    checkOptions(config = {}) {
      const { data, isAppenCard, cardConfig } = config
      const checkColId = this.checkColId
      if (checkColId.length === 0) {
        this.$message.warning('请先选择列')
        return
      }
      const tree = getParentNode(data)
      if (isAppenCard) {
        tree.cardConfig = cardConfig
        const row = {}
        const { title, type } = tree.targetField || {}
        if (['text', 'orders', 'status', 'textarea', 'radio', 'checkbox', 'label', 'time', 'number'].includes(type)) {
          row[title] = tree.value
        } else if (['relation-user', 'appuser'].includes(type)) {
          // 联系人控件
          if (Array.isArray(tree.value)) {
            row[title] = tree.value
          } else {
            row[title] = [{
              userId: tree.value.userId,
              realname: tree.value.value || tree.value.realname
            }]
          }
        }
        tree.dataRow = row
      }
      for (const id of this.checkColId) {
        if (this.tableData[id]) {
          const idx = this.tableData[id].findIndex(item => item.id === tree.id)
          if (idx > -1) {
            if (this.checkColId.length === 1) {
              this.$message.error('该选项已存在')
            } else {
              const idx = this.checkColId.indexOf(id)
              this.$message.error('该选项已存在第' + (idx + 1) + '列')
            }
            return
          } else {
            this.tableData[id].push(tree)
          }
        } else {
          this.tableData[id] = [tree]
        }
      }
    },
    resizeEnd(x, y, width) {
      // eslint-disable-next-line vue/no-mutating-props
      this.config.colWidth = width
    },
    changeActiveId(item) {
      if (this.activeColInfo.id === item.id) return
      this.checkColId = []
      this.$emit('changeActiveCol', item)
    },
    checkCol(col) {
      const idx = this.checkColId.indexOf(col.id)
      if (idx > -1) {
        this.checkColId.splice(idx, 1)
      } else {
        this.checkColId.push(col.id)
      }
    },
    goEditCol(col, idx) {
      this.tempColIdx = idx
      this.openType = 'col'
      const ref = this.$refs.colItemTitleRef[idx]
      const rect = ref.getBoundingClientRect()
      const option = { rect }
      this.$refs.colSetRef.open(col, option)
    },
    colSetConfirm(val, opt) {
      if (this.openType === 'col') {
        // eslint-disable-next-line vue/no-mutating-props
        this.activeColInfo.colItem[this.tempColIdx] = val
        this.tempColIdx = -1
      } else {
        // 批量设置
        this.$emit('changeBatchSet', val, opt)
      }
    },
    openBatchSet() {
      this.openType = 'total'
      const ref = this.$refs.colItemTitleRef[0]
      const rect = ref.getBoundingClientRect()
      const option = { rect, isBatch: true }
      this.$refs.colSetRef.open(undefined, option)
    },
  },
}
</script> 

<style scoped lang="scss">
.select-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #F6FAFE;
  padding: 0 20px;
  box-sizing: border-box;
  .select-table-content {
    width: 100%;
    display: flex;
    flex: 1;
    padding: 10px 0;
    box-sizing: border-box;
    .conent-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      &-nav {
        width: 100%;
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .nav-content {
          padding: 4px;
          box-sizing: border-box;
          background-color: #F2F0F1;
          border-radius: 20px;
          display: flex;
          &-item {
            height: 32px;
            line-height: 32px;
            padding: 0 28px;
            color: #333;
            box-sizing: border-box;
            border-radius: 20px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .nav-active {
            background-color: #fff;
          }
        }
      }

      .row-table-content {
        flex-direction: column;
        .row-item {
          flex-direction: row;
          margin-right: 0;
          margin-bottom: 10px;
          &-title {
            height: 100%;
            width: 60px;
            margin-right: 10px;
            margin-bottom: 0;
          }
          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }

      &-table {
        flex: 1;
        display: flex;
        width: 100%;
        padding-left: 10px;
        box-sizing: border-box;
        
        .col-item {
          flex: 1;
          margin-right: 10px;
          display: flex;
          flex-direction: column;
          min-width: 0;
          box-sizing: border-box;
          &-title {
            position: relative;
            z-index: 2;
            overflow: hidden;
            height: 60px;
            width: 100%;
            margin-bottom: 10px;
            background-color: #fff;
          }
          &-content {
            flex: 1;
            border: solid 2px transparent;
            box-sizing: border-box;
            background-color: #F0F0F3;
            border-radius: 8px;
            .check-draggable {
              height: 100%;
              width: 100%;
              overflow: auto;
              display: flex;
              align-content: start;
              flex-wrap: wrap;
              box-sizing: border-box;
              .check-card {
                padding: 5px;
                box-sizing: border-box;
                overflow: hidden;
                position: relative;
              }
              .check-item {
                padding: 5px 8px;
                height: fit-content;
                background-color: #4e86ff;
                color: #fff;
                border-radius: 4px;
                margin: 5px;
                cursor: move;
                display: flex;
                .close {
                  width: 14px;
                  height: 14px;
                  background-color: #fff;
                  margin-left: 5px;
                  border-radius: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  .el-icon-close {
                    font-size: 12px;
                    color: #4e86ff;
                    cursor: pointer;
                  }
                }
              }
            }
          }
          &:last-of-type {
            margin-right: 0;
          }
        }
        .col-item-active {
          border: solid 2px #4E86FF;
          box-shadow: 0px 0px 10px 0px rgba(78, 134, 255, 0.48);;
        }
      }
    }
    ::v-deep .handle-mr {
      width: 8px !important;
      height: 8px !important;
      border-radius: 100%;
      background-color: #4e86ff;
      opacity: 1;
      margin-right: 0;
      border: none;
      right: -5px !important;
    }
  }
}
</style>
